<template>
    <div class="login">
        <div class="inner">
            <div class="logo">
                <img src="/static/img/proebitda_logo.png" />
                <div class="slogan">
                    - Garanterede resultater
                </div>
            </div>
            
            <div class="box" v-if="!showResetPasswordForm">
                <div class="header">
                    Login
                </div>
                <div class="input username">
                    <label for="username">
                        Brugernavn
                    </label>
                    <input type="text" name="username" placeholder="Indtast brugernavn" v-model="username" @keydown.enter="login()" />
                </div>
                <div class="input password">
                    <label for="password">
                        Adgangskode
                    </label>
                    <input type="password" name="password" placeholder="Indtast adgangskode" v-model="password" @keydown.enter="login()" />
                </div>
                <div class="meta">
                    <div class="remember-me">
                        <input type="checkbox" name="remember" id="remember" v-model="rememberMe" />
                        <label for="remember">
                            Husk mig
                        </label>
                    </div>
                    <div class="forgot-password">
                        <a href="#" @click="toggleResetPasswordForm()">
                            Glemt adgangskode?
                        </a>
                    </div>
                </div>
                <div class="button" @click="login()">
                    Log ind
                </div>
            </div>

            <div class="box" v-else>
                <div v-if="!passwordResetted">
                    <div class="header">
                        Glemt adgangskode
                    </div>
                    <div class="input username">
                        <label for="username">
                            E-mail
                        </label>
                        <input type="text" name="email" placeholder="Indtast e-mail" v-model="username" @keydown.enter="doReset()" />
                    </div>
                    <div class="button" @click="doReset()">
                        Nulstil adgangskode
                    </div>
                </div>
                <div v-else>
                    Vi har nu nulstillet din adgangskode. Du bør have modtaget en e-mail med en midlertidig adgangskode. Når du logger ind næste gang, anbefaler vi, at du ændrer din kode til noget du selv kan huske.
                </div>
            </div>
            
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";
    
    .login {
        background: $color--dark;
        width: 100%;
        padding: 100px 0;
        min-height: 100vh;

        @media screen and (max-width: 768px) {
            padding-top: $padding--main * 2;
        }

        .inner {
            
            .logo {
                color: $color--white;
                text-align: center;
                margin-bottom: $margin--main;

                img {
                    width: 200px;
                    max-width: 100%;
                }

                .slogan {
                    margin-top: $margin--small / 2;
                    font-size: $fontsize--small;
                    font-family: $fontfamily--main;
                    font-weight: $fontweight--light;
                }
            }

            .box {
                margin: 0 auto;
                background: $color--white;
                width: 400px;
                max-width: calc(100% - #{$padding--main * 2});
                padding: $padding--main;
                border-radius: $borderradius--large;
                box-shadow: $boxshadow--creative;

                .header {
                    font-size: $fontsize--xl;
                    font-family: $fontfamily--main;
                    font-weight: $fontweight--bold;
                    margin-bottom: $margin--main;
                    text-align: center;
                }

                .input {

                    &.username {
                        margin-bottom: $margin--small;
                    }

                    label {
                        display: block;
                        margin-bottom: $margin--small / 2;
                        text-transform: uppercase;
                        color: $color--grey;
                        font-size: $fontsize--small;
                    }

                    input {
                        display: block;
                        height: 30px;
                        width: 100%;
                        border: none;
                        border-radius: $borderradius--main;
                        border: 1px solid $color--light;
                        font-size: $fontsize--sm;
                        padding: ($padding--small) ($padding--small / 2);
                        outline: none;

                        &::placeholder {
                            color: $color--light;
                        }

                        &:active, &:focus {
                            border-color: $color--dark;
                        }
                    }
                }

                .meta {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin: $margin--main 0;
                    font-size: $fontsize--sm;

                    .remember-me {

                        input {
                            margin-bottom: 0;
                        }
                    }

                    .forgot-password {

                        a {
                            color: $color--dark;
                            text-decoration: none;

                            &:hover {
                                text-decoration: underline;
                            }
                        }
                    }
                }

                .button {
                    background: $color--dark;
                    color: $color--white;
                    padding: $padding--small;
                    border-radius: $borderradius--main;
                    text-align: center;
                    font-weight: $fontweight--bold;
                    font-family: $fontfamily--main;
                    cursor: pointer;

                    &:hover {
                        background: darken($color--dark, 5%);
                    }
                }
            }
        }
    }

</style>

<script>
import * as userService from '@/services/userService'

export default {
    data () {
        return {
            username: '',
            password: '',
            rememberMe: false,
            showResetPasswordForm: false,
            passwordResetted: false
        }
    },
    created () {
        this.checkIfDemoEnvironment()
    },
    methods: {
        checkIfDemoEnvironment () {
            if (process.env.NODE_ENV === 'demo') {
                this.username = 'demo@proebitda.dk'
                this.password = 'demo'
            }
        },
        login () {
            const body = {
                username: this.username,
                password: this.password
            }
            this.$auth.login({
                data: body,
                rememberMe: this.rememberMe,
                fetchUser: true,
                redirect: {name: 'Index'},
                success: (response) => {
                    this.$emit('loggedIn')
                    this.$store.dispatch('getConfig')
                    let username = this.$auth.user().name.split(' ')[0]
                    this.$toastr('success', 'Velkommen, ' + username + '!', 'Logget ind')
                },
                error: (error) => {
                    console.log(error)
                }
            })
        },
        toggleResetPasswordForm () {
            this.showResetPasswordForm = true
        },
        doReset () {
            const params = {
                email: this.username
            }
            userService.forgotPassword(params, (response) => {
                this.passwordResetted = true
            }, (err) => {
                alert('Der skete desværre en fejl ved nulstilling af din adgangskode. Tjek, at du har skrevet en gyldig e-mail adresse og prøv venligst igen.')
                console.log(err)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// login.vue?47a2b21a